import React from 'react';

const PageLayout = ({ children, className = '' }) => (
  <div className={`space-y-6 ${className}`}>
    {children}
  </div>
);

export default PageLayout;
